import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link, useStaticQuery, graphql } from 'gatsby'
import parser from 'html-react-parser'

export default function NewsWidget({ data }) {
    const querydata = useStaticQuery(graphql`
    query {
      allWpPost(limit: 3, sort: { date: DESC }) {
        nodes {
          date(formatString: "MMMM DD, YYYY")
          categories {
            nodes {
              name
            }
          }
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData
                }
                publicURL
              }
            }
          }
          uri
          title
        }
      }
    }
  `)
    const { newsWidgetButtonText, newsWidgetSubtitle, newsWidgetTitle, newsWidgetButtonLink, newsWidgetButtonExternalLink } = data
    const blogPosts = querydata.allWpPost.nodes;
    console.log('blogposts', blogPosts);
    return (
        <div className='featured-blog-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center mb-4'>
                        <h2 className='heading-level-2 blue-color mb-4'>{newsWidgetTitle && parser(newsWidgetTitle)}</h2>
                        <p>
                            <strong>{newsWidgetSubtitle && parser(newsWidgetSubtitle)}</strong>
                        </p>
                    </div>
                </div>
                <div className='row f-blog-row'>
                    {blogPosts.map((post, index) => (
                        <div className='col-md-4' key={index}>
                            <Link to={post.uri}>
                                <div className='f-blog-col'>
                                    <figure>
                                        {post.featuredImage?.node?.localFile?.childImageSharp
                                            ?.gatsbyImageData ? (
                                            <GatsbyImage
                                                image={
                                                    post.featuredImage?.node?.localFile
                                                        ?.childImageSharp?.gatsbyImageData
                                                }
                                                alt='image'
                                                style={{ display: 'block' }}
                                            />
                                        ) : (
                                            <img
                                                src={post.featuredImage?.node?.localFile?.publicURL}
                                                alt='home'
                                                style={{ display: 'block' }}
                                            />
                                        )}
                                    </figure>
                                    <div className='f-blog-cate-sec'>
                                        <div className='category-col'>
                                            <span>
                                                {post.categories.nodes
                                                    .map(category => category.name)
                                                    .join(', ')}
                                            </span>
                                        </div>
                                        <div className='date-col'>
                                            <time>{post.date}</time>
                                        </div>
                                    </div>
                                    <figcaption className='heading-level-4-i text-uppercase'>
                                        {post.title}
                                    </figcaption>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        {newsWidgetButtonExternalLink ? (
                            <a href={newsWidgetButtonExternalLink} className="btn blue-btn">
                                {newsWidgetButtonText}
                            </a>
                        ) : newsWidgetButtonLink ? (
                            <Link to={newsWidgetButtonLink.uri} className='btn blue-btn'>
                                {newsWidgetButtonText}
                            </Link>
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}
